<template>
  <div>
    <b-row>
        <b-col sm="10">
          <b-form inline @submit.prevent="" class="mb-2">
            <b-input-group class="filter-group">
              <b-input-group-prepend is-text>
                <font-awesome-icon icon="search" />
              </b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button @click="filter = null">Clear</b-button>
              </b-input-group-append>
            </b-input-group>

            <b-input-group class="filter-group">
              <b-input-group-prepend is-text class="semester-input-group">
                Semester
              </b-input-group-prepend>
              <b-form-select v-model="selectedTerm"
                            :options="terms"
                            value-field="termId"
                            text-field="description"
                            />
            </b-input-group>

            <b-input-group class="filter-group">
              <b-input-group-prepend is-text class="semester-input-group">
                  Type
                </b-input-group-prepend>
              <b-form-select id="types" v-model="selectedType" :options="types" value-field="opportunityTypeId" text-field="name">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">All</option>
                </template>
              </b-form-select>
            </b-input-group>
          </b-form>
        </b-col>
        <b-col sm="2">
          <b-button class="new-opportunity-button float-right" :to="{name: 'opportunityAdd'}">
            <font-awesome-icon icon="plus" /> New Opportunity
          </b-button>
        </b-col>
      </b-row>

    <b-table striped
              hover
              :items="opportunities"
              :fields="fields"
              :sort-by="sortBy"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-compare="customSort"
              :filter="filterItems"
              @filtered="onFiltered"
              responsive
              small>
      <template slot="opportunityType" slot-scope="data">
        {{ data.item.opportunityType ? data.item.opportunityType.name : "" }}
      </template>
      <template slot="opportunityCategory" slot-scope="data">
        {{ data.item.opportunityCategory ? data.item.opportunityCategory.name : "" }}
      </template>
      <template slot="translationalTeam" slot-scope="data">
        {{ data.item.translationalTeam ? data.item.translationalTeam.name : "" }}
      </template>
      <template slot="site" slot-scope="data">
        {{ data.item.site ? data.item.site.name : "" }}
      </template>
      <template slot="term" slot-scope="data">
        {{ data.item.term ? data.item.term.description : "" }}
      </template>
      <template slot="published" slot-scope="data">
        {{ data.item.published ? "Yes" : "No"}}
      </template>
      <template slot="details" slot-scope="data">
        <router-link :to="{ name: 'opportunity', params: {opportunityId: data.item.opportunityId } }">Details</router-link>
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import roleChecks from "../../misc/role-checks";

export default {
  mixins: [roleChecks],
  name: "OpportunitiesList",
  data() {
    return {
      fields: [
        { key: "name", label: "Name / Title", sortable: true },
        { key: "opportunityType", label: "Type", sortable: true },
        { key: "opportunityCategory", label: "Category", sortable: true },
        { key: "translationalTeam" },
        { key: "site", sortable: true },
        {
          key: "term",
          label: "Semester"
        },
        {
          key: "pendingStudentOpportunityCount",
          label: "Pending Student Opportunities",
          sortable: true
        },
        { key: "positionsAvailable", sortable: true },
        { key: "published", sortable: true },
        { key: "details", label: "" }
      ],
      sortBy: "opportunityCategory",
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      selectedTerm: 0,
      selectedType: null
    };
  },

  props: {
    opportunities: {
      type: Array,
      required: true
    },
    terms: {
      type: Array,
      required: true
    },
    term: null,
    types: {
      type: Array,
      required: true
    },
    type: null
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  watch: {
    opportunities: function() {
      this.totalRows = this.opportunities.length;
    },
    selectedTerm: function(value) {
      this.$emit("term-change", value);
    },
    term: function() {
      if (this.term != null) {
        this.selectedTerm = this.term;
      }
    },
    type: function() {
      if (this.type != null) {
        this.selectedType = this.type;
      }
    }
  },

  methods: {
    customSort(a, b, key) {
      //   { key: "positionsAvailable", sortable: true },
      //   { key: "published", sortable: true },

      var categoryNameA;
      var categoryNameB;
      if (key === "name") {
        categoryNameA = a.name ? a.name : "";
        categoryNameB = b.opportunityCategory ? b.opportunityCategory.name : "";
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "opportunityType") {
        categoryNameA = a.opportunityType ? a.opportunityType.name : "";
        categoryNameB = b.opportunityType ? b.opportunityType.name : "";
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "opportunityCategory") {
        categoryNameA = a.opportunityCategory ? a.opportunityCategory.name : "";
        categoryNameB = b.opportunityCategory ? b.opportunityCategory.name : "";
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "translationalTeam") {
        categoryNameA = a.translationalTeam ? a.translationalTeam.name : "";
        categoryNameB = b.translationalTeam ? b.translationalTeam.name : "";
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "pendingStudentOpportunityCount") {
        categoryNameA = a.pendingStudentOpportunityCount
          ? a.pendingStudentOpportunityCount.toString()
          : "";
        categoryNameB = b.pendingStudentOpportunityCount
          ? b.pendingStudentOpportunityCount.toString()
          : "";
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "positionsAvailable") {
        categoryNameA = a.positionsAvailable
          ? a.positionsAvailable.toString()
          : "";
        categoryNameB = b.positionsAvailable
          ? b.positionsAvailable.toString()
          : "";
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "published") {
        categoryNameA = a.published ? a.published.toString() : "";
        categoryNameB = b.published ? b.published.toString() : "";
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "site") {
        categoryNameA = a.site.name;
        categoryNameB = b.site.name;
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "term") {
        categoryNameA = a.term.description;
        categoryNameB = b.term.description;
        return categoryNameA.localeCompare(categoryNameB);
      } else {
        return null;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filterItems(item) {
      var matchedTerm = this.matchTerm(item, this.selectedTerm);
      var matchedFilter = this.matchFilter(item, this.filter);
      var matchedType = this.matchType(item, this.selectedType);

      if (matchedTerm && matchedFilter && matchedType) {
        return true;
      }
      return false;
    },
    matchTerm(item, term) {
      if (item.term.termId === term || term === null || term === 0) {
        return true;
      }
      return false;
    },
    matchType(item, type) {
      if (type === null || item.opportunityType.opportunityTypeId === type) {
        return true;
      }
      return false;
    },
    matchFilter(item, filter) {
      if (filter != "" && filter != null) {
        var found = this.search([item], this.filter);
        return found.length > 0;
      }
      return true;
    },
    search(collection, text) {
      var that = this;
      return _.filter(collection, function(object) {
        var search = that.deepSearch(object, text.toLowerCase());
        return _.keys(search).length > 0;
      });
    },
    deepSearch(collection, predicate, thisArg) {
      if (_.isFunction(predicate)) {
        predicate = _.iteratee(predicate, thisArg);
      } else {
        var keys = _.flatten(_.tail(arguments));
        if (typeof keys === "string") {
          keys = keys.toLowerCase();
        }
        predicate = function(val, key) {
          if (typeof val === "string") {
            val = val.toLowerCase();
          }
          return _.includes(val, keys);
        };
      }
      var that = this;
      return _.transform(collection, function(memo, val, key) {
        var include = predicate(val, key);
        if (!include && _.isObject(val)) {
          val = that.deepSearch(val, predicate);
          include = !_.isEmpty(val);
        }
        if (include) {
          _.isArray(collection) ? memo.push(val) : (memo[key] = val);
        }
      });
    }
  },
  created() {
    // fields are different depending on user roles
    if (this.isContractManager) {
      this.fields.splice(-1, 0, { key: "status", sortable: true });
    }
  }
};
</script>

<style scoped>
.filter-group {
  max-width: 700px;
}

.filter-group,
.new-opportunity-button {
  margin: 10px 0 15px 0;
}

.semester-input-group {
  margin-left: 10px;
}
</style>
